import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tile-modal" }
const _hoisted_2 = {
  class: "tile-modal-inner hide-scrollbar",
  ref: "innerModal"
}
const _hoisted_3 = { class: "modal-hub" }
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "anim-elem1 cls-1",
    d: "M82.6,144.3c-21.1-2.4-43.2-10.5-43.2-46.9a36,36,0,0,1,9.8-25.5,33.5,33.5,0,0,1,.9-25.1s7.9-2.6,26.1,9.7a89.1,89.1,0,0,1,47.5,0c18.1-12.3,26.1-9.7,26.1-9.7a34,34,0,0,1,.9,25.1,36.8,36.8,0,0,1,9.8,25.5c0,36.4-22.1,44.4-43.3,46.8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "cls-1",
    d: "M117.2,144.2a22.7,22.7,0,0,1,6.4,17.7v26c0,3.2,1.7,5.5,6.5,4.5a95.1,95.1,0,1,0-60.1,0c4.7.9,6.5-2,6.5-4.4V171.9c-26.5,5.7-32-12.8-32-12.8a25.4,25.4,0,0,0-10.7-14c-8.7-5.9.6-5.8.6-5.8a19.4,19.4,0,0,1,14.5,9.8c8.5,14.5,22.1,10.3,27.7,7.9a20.5,20.5,0,0,1,6-12.7"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"><circle class=\"cls-1\" cx=\"100\" cy=\"100\" r=\"95\"></circle><path class=\"cls-1 anim-elem2\" d=\"M100,195c29.4,0,53.2-42.5,53.2-95S129.4,5,100,5\"></path><path class=\"cls-1 anim-elem1\" d=\"M100,5C70.6,5,46.8,47.5,46.8,100s23.8,95,53.2,95\"></path><path class=\"cls-1\" d=\"M176.6,43.8C159.3,57,131.4,65.6,100,65.6S40.7,57,23.4,43.8\"></path><path class=\"cls-1\" d=\"M176.6,156.2c-17.3-13.2-45.2-21.8-76.6-21.8S40.7,143,23.4,156.2\"></path><line class=\"cls-1\" x1=\"100\" y1=\"5\" x2=\"100\" y2=\"195\"></line></svg>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "modal-content wrapper" }
const _hoisted_11 = { class: "project-overview glass-tile" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", {
  class: "project-heading",
  "data-text": "Overview"
}, null, -1)
const _hoisted_13 = { class: "desc-elem-inner" }
const _hoisted_14 = { class: "project-desc" }
const _hoisted_15 = { class: "desc-elem project-about glass-tile" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", {
  class: "project-heading",
  "data-text": "About"
}, null, -1)
const _hoisted_17 = { class: "desc-elem-inner" }
const _hoisted_18 = { class: "desc-elem project-stack glass-tile" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", {
  class: "project-heading",
  "data-text": "stack"
}, null, -1)
const _hoisted_20 = { class: "desc-elem-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TileDisplay = _resolveComponent("TileDisplay")!
  const _component_CloseBtn = _resolveComponent("CloseBtn")!
  const _component_ProjectMockup = _resolveComponent("ProjectMockup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TileDisplay, { data: _ctx.data }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.data.gitHubLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.data.gitHubLink,
              target: "_blank",
              "aria-label": "Project GitHub Repository Link",
              class: "modal-hub-link mh-link1"
            }, _hoisted_6, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.data.pageLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _ctx.data.pageLink,
              target: "_blank",
              "aria-label": "Hosted Project Link",
              class: "modal-hub-link mh-link2"
            }, _hoisted_9, 8, _hoisted_7))
          : _createCommentVNode("", true),
        _createVNode(_component_CloseBtn, {
          glassTile: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                        _ctx.scrollTopModal(),
                        _ctx.$emit('hideModals')
                    ))
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.overview, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
            }), 128))
          ])
        ]),
        _createVNode(_component_ProjectMockup, { data: _ctx.data }, null, 8, ["data"]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.about, (paragraph, index) => {
                return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stack, (paragraph, index) => {
                return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
              }), 128))
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}